{
  "title": "Settings",
  "panel": {
    "createTitle": "Create {{title}}",
    "updateTitle": "Update {{title}}",
    "createDescription": "Create {{title}}.",
    "updateDescription": "Update {{title}}.",
    "removeTitle": "Remove {{title}}",
    "removeText": "Are you sure you want to remove this {{title}}? This action cannot be undone.",
    "closePanel": "Close panel",
    "remove": "Remove",
    "test": "Test",
    "ok": "OK!",
    "error": "ERROR",
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save"
  },
  "nav": {
    "application": "Application",
    "logs": "Logs",
    "indexers": "Indexers",
    "irc": "IRC",
    "feeds": "Feeds",
    "lists": "Lists",
    "clients": "Clients",
    "notifications": "Notifications",
    "apiKeys": "API keys",
    "proxies": "Proxies",
    "releases": "Releases",
    "account": "Account"
  },
  "application": {
    "title": "Application",
    "description": "Application settings. Change in config.toml and restart to take effect.",
    "host": "Host",
    "port": "Port",
    "baseUrl": "Base URL",
    "version": "Version",
    "commit": "Commit",
    "buildDate": "Build date",
    "application": "Application",
    "configPath": "Config path",
    "database": "Database",
    "webuiDebugMode": "WebUI Debug mode",
    "checkForUpdates": "Check for updates",
    "checkForUpdatesDescription": "Get notified of new updates.",
    "theme": "Theme",
    "themeDescription": "Choose between light, dark, or follow system theme.",
    "languageDescription": "Choose the language used in the WebUI.",
    "updateEnabled": "You will now be notified of new updates.",
    "updateDisabled": "You will no longer be notified of new updates.",
    "updateAvailable": "{{name}} available!"
  },
  "account": {
    "title": "Account",
    "description": "Manage account settings.",
    "required": "Required",
    "passwordsDoNotMatch": "Passwords don't match!",
    "updateSuccess": "User updated successfully. Please sign in again!",
    "updateError": "Error updating credentials. Did you provide the correct current password?",
    "changeCredentialsTitle": "Change credentials",
    "changeCredentialsDescription": "The username and password can be changed either separately or simultaneously. Note that you will be logged out after changing credentials.",
    "currentUsername": "Current Username",
    "newUsername": "New Username",
    "optional": "Optional",
    "currentPassword": "Current Password",
    "requiredIfUpdatingCredentials": "Required if updating credentials",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "save": "Save",
    "identityProvider": "your identity provider",
    "oidcTitle": "OpenID Connect Account",
    "oidcDescription": "Your account credentials are managed by your OpenID Connect provider. To change your username, please visit your provider's settings page and log in again.",
    "authenticatedViaOidc": "Authenticated via OpenID Connect"
  },
  "logsPage": {
    "title": "Logs",
    "description": "Configure log level, log size rotation, etc. You can download your old log files below.",
    "chooseType": "Choose a type",
    "updated": "Config successfully updated!",
    "path": "Path",
    "setInConfig": "Set in config.toml",
    "notSet": "Not set!",
    "level": "Level",
    "logLevel": "Log level",
    "maxSize": "Max Size",
    "maxBackups": "Max Backups"
  },
  "regexPlayground": {
    "title": "Regex Playground",
    "description": "Regex playground. Experiment with your filters here. WIP.",
    "regexFilter": "RegExp filter",
    "linesToMatch": "Lines to match",
    "matches": "Matches"
  },
  "apiKey": {
    "createTitle": "Create API key",
    "description": "Add new API key.",
    "created": "API key {{name}} was added",
    "deleted": "API key {{name}} was deleted",
    "name": "Name",
    "key": "Key",
    "required": "Required",
    "closePanel": "Close panel",
    "cancel": "Cancel",
    "create": "Create",
    "listTitle": "API keys",
    "listDescription": "Manage your autobrr API keys here.",
    "addNew": "Add new",
    "noItems": "No API keys",
    "createCta": "Create API key",
    "removeTitle": "Remove API key: {{name}}",
    "removeText": "Are you sure you want to remove this API key? This action cannot be undone.",
    "deleteKey": "Delete key"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "IRC networks and channels. Click on a network to view channel status.",
    "addNew": "Add new",
    "networkHealthy": "Network healthy",
    "networkUnhealthy": "Network unhealthy",
    "networkDisabled": "Network disabled",
    "collapseTitle": "collapse",
    "expandTitle": "expand",
    "collapse": "Collapse",
    "expand": "Expand",
    "network": "Network",
    "noNetworks": "No networks",
    "noNetworksSubtitle": "Normally set up via Indexers",
    "addNewNetwork": "Add new network",
    "toggleSuccess": "{{name}} was {{state}} successfully.",
    "enabledState": "enabled",
    "disabledState": "disabled",
    "connectedSince": "Connected since: {{time}}",
    "tlsSecured": "Secured using TLS",
    "tlsInsecure": "Insecure, not using TLS",
    "channel": "Channel",
    "monitoringSince": "Monitoring since",
    "lastAnnounce": "Last announce",
    "monitoring": "monitoring",
    "hide": "Hide",
    "view": "View",
    "networkDeleted": "Network {{name}} was deleted",
    "networkRestarted": "{{name}} was successfully restarted",
    "removeNetworkTitle": "Remove network: {{name}}",
    "removeNetworkText": "Are you sure you want to remove this network? This action cannot be undone.",
    "edit": "Edit",
    "restart": "Restart",
    "delete": "Delete",
    "announceReprocessed": "Announce sent to re-process!",
    "reprocessAnnounce": "Re-process announce",
    "options": "Options",
    "scrollOnNewMessage": "Scroll to bottom on new message",
    "title": "Network",
    "addWarning": "ADD NETWORKS VIA INDEXERS! ONLY USE THIS IF YOU DELETED NETWORKS",
    "added": "IRC Network added. Please allow up to 30 seconds for the network to come online.",
    "addFailed": "IRC Network could not be added",
    "updated": "{{name}} was updated successfully",
    "deleted": "{{name}} was deleted.",
    "required": "Required",
    "name": "Name",
    "enabled": "Enabled",
    "server": "Server",
    "serverPlaceholder": "Address: Eg irc.server.net",
    "port": "Port",
    "portPlaceholder": "Eg 6667",
    "tls": "TLS",
    "skipTls": "Skip TLS verification (insecure)",
    "password": "Password",
    "passwordHelp": "Network password",
    "passwordUpdateHelp": "Network password, not commonly used.",
    "nick": "Nick",
    "nickPlaceholderAdd": "bot nick",
    "nickPlaceholderUpdate": "nick",
    "authAccount": "Auth Account",
    "authAccountPlaceholder": "Auth Account",
    "authPassword": "Auth Password",
    "inviteCommand": "Invite command",
    "channels": "Channels",
    "channelsDesc": "Channels to join.",
    "channelsUpdateDesc": "Channels are added when you setup IRC indexers. Do not edit unless you know what you are doing.",
    "channelPassword": "Channel password",
    "remove": "Remove",
    "noChannels": "No channels!",
    "addChannel": "Add Channel",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Bouncer address",
    "bouncerAddressHelp": "Address: Eg bouncer.server.net:6697",
    "botMode": "IRCv3 Bot Mode",
    "proxy": "Proxy",
    "proxyDesc": "Set a proxy to be used for connecting to the IRC server.",
    "selectProxy": "Select proxy",
    "selectProxyPlaceholder": "Select a proxy",
    "identification": "Identification",
    "identificationDesc": "Identify with SASL or NickServ. Most networks support SASL but some don't.",
    "mechanism": "Mechanism",
    "account": "Account",
    "accountHelp": "NickServ / SASL account. For grouped nicks try the main.",
    "passwordSaslHelp": "NickServ / SASL password.",
    "chooseType": "Choose a type"
  },
  "releases": {
    "warningTitle": "Warning:",
    "warningBody": "This section manages release history deletion. Automated cleanup jobs run on schedules, while manual deletion allows immediate one-time cleanup. Both operations permanently delete data and cannot be undone.",
    "olderThan": "Older than",
    "olderThanDesc": "How old releases must be before deletion (Required for both automated and manual deletion)",
    "indexers": "Indexers",
    "indexersDesc": "Optional filter (if none selected, applies to all indexers)",
    "releaseStatuses": "Release statuses",
    "releaseStatusesDesc": "Optional filter (if none selected, applies to all release statuses)",
    "duplicateProfilesTitle": "Release Duplicate Profiles",
    "duplicateProfilesDesc": "Manage duplicate profiles.",
    "cleanupJobsTitle": "Release Cleanup Jobs",
    "cleanupJobsDesc": "Schedule automatic cleanup of old releases with custom filters.",
    "addNew": "Add new",
    "edit": "Edit",
    "enabled": "Enabled",
    "name": "Name",
    "lastRun": "Last Run",
    "nextRun": "Next Run",
    "runNow": "Run now",
    "delete": "Delete",
    "never": "Never",
    "deleteReleaseHistory": "Delete release history",
    "deleteReleaseHistoryDesc": "Select the criteria below to permanently delete release history records that are older than the chosen age and optionally match the selected indexers and release statuses:",
    "removeReleases": "Remove releases",
    "invalidAge": "Please select a valid age.",
    "invalidAgeExample": "Please enter a valid age. For example, 6 months or 1 year.",
    "allDeleted": "All releases based on criteria were deleted.",
    "olderThanDeleted": "Releases older than {{duration}} were deleted.",
    "allIndexers": "all indexers",
    "selectedIndexers": "the chosen indexers",
    "removeCleanupJobTitle": "Remove cleanup job: {{name}}",
    "removeCleanupJobText": "Are you sure you want to remove this cleanup job? This action cannot be undone.",
    "cleanupJobToggled": "{{name}} {{state}}",
    "cleanupJobTriggered": "{{name}} triggered",
    "cleanupJobDeleted": "{{name}} deleted",
    "cleanupJobEnabled": "enabled",
    "cleanupJobDisabled": "disabled",
    "duplicateFieldTitles": {
      "releaseName": "Release name",
      "hash": "Normalized hash of the release name. Use with Release name for exact match",
      "title": "Parsed title",
      "subTitle": "Parsed sub title like Episode name",
      "group": "Release group",
      "year": "Year",
      "month": "Month",
      "day": "Day",
      "source": "Source",
      "resolution": "Resolution",
      "codec": "Codec",
      "container": "Container",
      "dynamicRange": "Dynamic Range (HDR,DV)",
      "audio": "Audio formats",
      "season": "Season number",
      "episode": "Episode number",
      "website": "Website/Service",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "Edition (eg. Collectors Edition) and Cut (eg. Directors Cut)",
      "language": "Language and Region"
    },
    "noDuplicateProfiles": "No duplicate release profiles",
    "addNewProfile": "Add new profile",
    "noCleanupJobs": "No cleanup jobs",
    "createCleanupSchedules": "Create automated cleanup schedules",
    "addNewJob": "Add new job",
    "removeReleasesText": "You are about to {{scope}}.",
    "removeReleasesScopeAll": "delete all release history records for {{indexers}}{{statuses}}",
    "removeReleasesScopeOlder": "permanently delete all release history records older than {{duration}} for {{indexers}}{{statuses}}",
    "removeReleasesStatuses": " and with the following release statuses: {{statuses}}",
    "duration": {
      "allTime": "all time",
      "hour1": "1 hour",
      "hours12": "12 hours",
      "day1": "1 day",
      "week1": "1 week",
      "month1": "1 month",
      "months3": "3 months",
      "months6": "6 months",
      "year1": "1 year",
      "invalid": "Invalid duration"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "Remove",
      "test": "Test",
      "ok": "OK!",
      "error": "ERROR",
      "cancel": "Cancel",
      "create": "Create",
      "save": "Save",
      "added": "Client was added",
      "addFailed": "Client could not be added",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "addTitle": "Add client",
      "addDescription": "Add download client.",
      "editTitle": "Edit client",
      "editDescription": "Edit download client settings.",
      "removeTitle": "Remove download client",
      "removeText": "Are you sure you want to remove this download client? This action cannot be undone.",
      "closePanel": "Close panel",
      "name": "Name",
      "enabled": "Enabled",
      "type": "Type",
      "host": "Host",
      "port": "Port",
      "tls": "TLS",
      "skipTls": "Skip TLS verification (insecure)",
      "username": "Username",
      "password": "Password",
      "apiKey": "API key",
      "authToken": "Auth token",
      "basicAuth": "Basic auth",
      "auth": "Auth",
      "authType": "Auth type",
      "selectAuthType": "Select auth type",
      "authTypeTooltip": "This should in most cases be Basic Auth, but some providers use Digest Auth.",
      "hostHelpDeluge": "Eg. client.domain.ltd, domain.ltd/client, domain.ltd:port",
      "hostHelpArr": "Full url http(s)://domain.ltd and/or subdomain/subfolder",
      "hostHelpQbit": "Eg. http(s)://client.domain.ltd, http(s)://domain.ltd/qbittorrent, http://domain.ltd:port",
      "hostHelpPorla": "Eg. http(s)://client.domain.ltd, http(s)://domain.ltd/porla, http://domain.ltd:port",
      "hostHelpRTorrent": "Eg. http(s)://client.domain.ltd/RPC2, http(s)://domain.ltd/client, http(s)://domain.ltd/RPC2",
      "hostHelpTransmission": "Eg. http(s)://client.domain.ltd, http(s)://domain.ltd/transmission",
      "hostHelpSabnzbd": "Eg. http://ip:port or https://url.com/sabnzbd",
      "hostHelpNzbget": "Eg. http://localhost:6789",
      "daemonPort": "Daemon port",
      "webUiPortQbit": "WebUI port for qBittorrent",
      "transmissionPort": "Port for Transmission",
      "sabnzbdPort": "port for SABnzbd",
      "guidesDeluge": "See guides for how to connect to Deluge for various server types in our docs.",
      "guidesArr": "See guides for how to connect to the *arr suite for various server types in our docs.",
      "guidesQbit": "See guides for how to connect to qBittorrent for various server types in our docs.",
      "guidesRTorrent": "See guides for how to connect to rTorrent for various server types in our docs.",
      "guidesTransmission": "See guides for how to connect to Transmission for various server types in our docs.",
      "guidesSabnzbd": "See our guides on how to connect to SABnzbd for various server types in our docs.",
      "dedicatedServers": "Dedicated servers:",
      "sharedSeedboxProviders": "Shared seedbox providers:",
      "rulesTitle": "Rules",
      "rulesDescriptionBasic": "Manage max downloads.",
      "rulesDescriptionAdvanced": "Manage max downloads etc.",
      "maxActiveDownloads": "Max active downloads",
      "maxActiveDownloadsTooltip": "Limit the amount of active downloads (0 is unlimited), to give the maximum amount of bandwidth and disk for the downloads.",
      "seeRecommendations": "See recommendations for various server types here:",
      "downloadClientTitle": "Download Client",
      "downloadClientDescription": "Override download client to use. Can also be overridden per Filter Action.",
      "clientName": "Client Name",
      "clientNameTooltip": "Specify what client the arr should use by default. Can be overridden per filter action.",
      "clientIdDeprecated": "Client ID DEPRECATED",
      "clientIdDeprecatedTooltip": "DEPRECATED: Use Client name field instead.",
      "ignoreSlowTorrents": "Ignore slow torrents",
      "ignoreCondition": "Ignore condition",
      "selectIgnoreCondition": "Select ignore condition",
      "ignoreConditionTooltip": "Choose whether to respect or ignore the Max active downloads setting before checking speed thresholds.",
      "downloadSpeedThreshold": "Download speed threshold",
      "uploadSpeedThreshold": "Upload speed threshold",
      "speedThresholdPlaceholder": "in KB/s",
      "downloadSpeedThresholdHelp": "If download speed is below this when max active downloads is hit, download anyways. KB/s",
      "uploadSpeedThresholdHelp": "If upload speed is below this when max active downloads is hit, download anyways. KB/s"
    },
    "feed": {
      "title": "Feed",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "testOk": "{{name}} test OK!",
      "name": "Name",
      "type": "Type",
      "enabled": "Enabled",
      "warningTitle": "Warning: Indexers might ban you for too low interval!",
      "warningText": "Read the indexer rules.",
      "url": "URL",
      "torznabUrlHelp": "Torznab URL. Use only the URL without extra params.",
      "newznabUrlHelp": "Newznab URL. Use only the URL without extra params.",
      "rssUrlHelp": "RSS URL",
      "urlFormatTitle": "Prowlarr and Jackett have different formats:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "Download type",
      "apiKey": "API key",
      "skipTls": "Skip TLS verification (insecure)",
      "refreshInterval": "Refresh interval",
      "refreshIntervalHelp": "Minutes. Recommended 15-30. Too low may risk a ban.",
      "refreshTimeout": "Refresh timeout",
      "refreshTimeoutHelp": "Seconds to wait before cancelling refresh.",
      "maxAge": "Max age",
      "maxAgeHelp": "Maximum age of feed content in seconds. Use 0 to disable the age filter and process all items.",
      "cookie": "Cookie",
      "cookieHelp": "Not commonly used",
      "categoriesTitle": "Categories",
      "categoriesDescription": "Fetch available categories and select what to include.",
      "fetch": "Fetch",
      "fetching": "Fetching",
      "refetch": "Refetch",
      "fetchFailed": "Failed to fetch categories",
      "noCategories": "No categories found.",
      "fetchToSelect": "Fetch categories to select."
    },
    "list": {
      "added": "List added!",
      "addFailed": "List could not be added",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "name": "Name",
      "type": "Type",
      "enabled": "Enabled",
      "filters": "Filters",
      "addTitle": "Add List",
      "updateTitle": "Update List",
      "description": "Auto update filters from lists and arrs.",
      "closePanel": "Close panel",
      "chooseType": "Choose a type",
      "chooseClient": "Choose a client",
      "selectClient": "Select Client",
      "selectClientLabel": "Select Client",
      "filtersDescription": "Select filters to update for this list.",
      "cancel": "Cancel",
      "remove": "Remove",
      "save": "Save",
      "saving": "Saving..",
      "selectSomeItems": "Select...",
      "allItemsSelected": "All items are selected",
      "selectAll": "Select all",
      "search": "Search",
      "noOptions": "No options",
      "removeTitle": "Remove {{name}}",
      "removeText": "Are you sure you want to remove {{name}}? This action cannot be undone.",
      "required": "Required",
      "settingsLegend": "Settings",
      "source": "Source",
      "sourceList": "Source list",
      "arrSourceDescription": "Update filters from titles in Radarr, Sonarr, Lidarr, Readarr, or Whisparr.",
      "traktSourceDescription": "Use a Trakt list or one of the default autobrr hosted lists.",
      "anilistSourceDescription": "Use an AniList list from one of the default autobrr hosted lists.",
      "plaintextSourceDescription": "Use a plain text list with one item per line.",
      "steamSourceDescription": "Follow Steam wishlists.",
      "metacriticSourceDescription": "Use a Metacritic list or one of the default autobrr hosted lists.",
      "mdblistSourceDescription": "Use a MDBList list or one of the default autobrr hosted lists.",
      "listUrl": "List URL",
      "traktHelp": "Default Trakt lists. Override with your own.",
      "traktApiKey": "API Key",
      "traktApiKeyHelp": "Trakt API Key. Required for private lists.",
      "matchRelease": "Match Release",
      "matchReleaseDesc": "Use Match Releases field. Uses Movies/Shows field by default.",
      "includeUnmonitored": "Include Unmonitored",
      "includeUnmonitoredDesc": "By default only monitored titles are filtered.",
      "includeAlternateTitles": "Include Alternate Titles",
      "includeAlternateTitlesDesc": "Include alternate titles in the filter.",
      "skipCleanSanitize": "Bypass cleanup and sanitization and use the list as-is",
      "skipCleanSanitizeDesc": "By default, titles are automatically sanitized and checked for unusual characters.",
      "tagsIncluded": "Tags Included",
      "tagsExcluded": "Tags Excluded",
      "metacriticHelp": "Metacritic lists. Override with your own.",
      "mdblistHelp": "MDBLists.com lists. Override with your own.",
      "includeYear": "Include Year",
      "includeYearDesc": "Include the release year in the filter for movies. Requires Match Releases. Example: Movie?Title?2024*",
      "plaintextUrlHelp": "URL to a plain text file with one item per line",
      "plaintextUrlPlaceholder": "https://example.com/list.txt",
      "plaintextTooltip1": "Plaintext lists can read from both HTTP URLs and local files on disk.",
      "plaintextTooltipRemote": "Remote: https://service.com/file.txt",
      "plaintextTooltipLocal": "Local: file:///home/username/file.txt",
      "url": "URL",
      "steamUrlHelp": "Steam Wishlist URL",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/USERNAME/wishlistdata"
    },
    "proxy": {
      "title": "Proxy",
      "addTitle": "Add proxy",
      "addDescription": "Add proxy to be used with Indexers or IRC.",
      "added": "Proxy added!",
      "addFailed": "Proxy could not be added",
      "updated": "Proxy {{name}} updated!",
      "updateFailed": "Proxy could not be updated",
      "deleted": "Proxy {{name}} was deleted.",
      "name": "Name",
      "closePanel": "Close panel",
      "enabled": "Enabled",
      "proxyType": "Proxy type",
      "proxyTypeTooltip": "Proxy type. Commonly SOCKS5.",
      "proxyTypeHelp": "Usually SOCKS5",
      "addr": "Addr",
      "addrHelp": "Addr: scheme://ip:port or scheme://domain",
      "user": "User",
      "userHelp": "auth: username",
      "pass": "Pass",
      "passHelp": "auth: password",
      "test": "Test",
      "cancel": "Cancel",
      "save": "Save"
    },
  "apiKey": {
    "createTitle": "Create API key",
    "description": "Add new API key.",
    "created": "API key {{name}} was added",
    "deleted": "API key {{name}} was deleted",
    "name": "Name",
    "key": "Key",
    "required": "Required",
    "closePanel": "Close panel",
    "cancel": "Cancel",
    "create": "Create",
    "listTitle": "API keys",
    "listDescription": "Manage your autobrr API keys here.",
    "addNew": "Add new",
    "noItems": "No API keys",
    "createCta": "Create API key",
    "removeTitle": "Remove API key: {{name}}",
    "removeText": "Are you sure you want to remove this API key? This action cannot be undone.",
    "deleteKey": "Delete key"
  },
    "notification": {
      "settings": "Settings",
      "settingsDescDiscordPrefix": "Create a ",
      "settingsDescDiscordSuffix": " in your server.",
      "discordWebhookIntegration": "webhook integration",
      "settingsDescNotifiarr": "Enable the autobrr integration and optionally create a new API Key.",
      "settingsDescLunasea1": "LunaSea offers notifications across all devices linked to your account (User-Based) or to a single device without an account, using a unique webhook per device (Device-Based).",
      "settingsDescLunasea2Prefix": "Read the ",
      "settingsDescLunasea2Suffix": ".",
      "lunaseaDocs": "LunaSea docs",
      "settingsDescTelegramPrefix": "Read how to ",
      "settingsDescTelegramSuffix": ".",
      "createBot": "create a bot",
      "settingsDescPushoverPrefix": "Register a new ",
      "settingsDescPushoverSuffix": " and add its API Token here.",
      "pushoverApplication": "application",
      "eventSounds": "Event sounds",
      "eventSoundsDesc": "Set custom sounds per event",
      "settingsDescWebhook": "Send a generic autobrr JSON payload to a user-defined webhook URL.",
      "added": "Notification added!",
      "addFailed": "Notification could not be added",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "required": "Required",
      "addTitle": "Add Notifications",
      "addDescription": "Trigger notifications on different events.",
      "title": "Notification",
      "name": "Name",
      "type": "Type",
      "enabled": "Enabled",
      "chooseType": "Choose a type",
      "closePanel": "Close panel",
      "globalEvents": "Global Events",
      "globalEventsDesc": "Select default events that trigger globally. These can be overridden on a per-filter basis. Leave all unchecked to use this service only for filter-specific notifications.",
      "perFilterEvents": "Per-filter Events",
      "perFilterEventsDesc": "This notification is used in these filters.",
      "notUsedInFilters": "Not used in any filters",
      "muted": "Muted",
      "test": "Test",
      "cancel": "Cancel",
      "save": "Save",
      "notificationsLegend": "Notifications",
      "defaultTone": "Default (user's default tone)",
      "webhookUrl": "Webhook URL",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "Discord channel webhook URL",
      "notifiarrApiKey": "API Key",
      "notifiarrApiKeyHelp": "Notifiarr API Key",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "LunaSea Webhook URL",
      "botToken": "Bot token",
      "botTokenHelp": "Bot token",
      "chatId": "Chat ID",
      "chatIdHelp": "Chat ID",
      "messageThreadId": "Message Thread ID",
      "messageThreadIdHelp": "Message Thread (topic) of a Supergroup",
      "telegramProxy": "Telegram API Proxy",
      "telegramProxyHelp": "Reverse proxy domain for api.telegram.org. Only needed if your network blocks the Telegram API.",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "Sender",
      "senderHelp": "Custom sender name shown at the top of a notification",
      "senderPlaceholder": "autobrr",
      "apiToken": "API Token",
      "apiTokenHelp": "API Token",
      "userKey": "User Key",
      "userKeyHelp": "User Key",
      "priority": "Priority",
      "pushoverPriorityHelp": "-2, -1, 0 (default), 1, or 2",
      "gotifyUrl": "Gotify URL",
      "gotifyUrlHelp": "Gotify URL (without /message)",
      "gotifyUrlPlaceholder": "https://some.gotify.server.com",
      "applicationToken": "Application Token",
      "applicationTokenHelp": "Application Token",
      "ntfyUrl": "NTFY URL",
      "ntfyUrlHelp": "NTFY URL",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
      "username": "Username",
      "usernameHelp": "Username",
      "password": "Password",
      "passwordHelp": "Password",
      "accessToken": "Access token",
      "accessTokenHelp": "Access token. Use this or Username + password",
      "ntfyPriorityHelp": "Max 5, 4, 3 (default), 2, 1 Min",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "See full documentation ",
      "shoutrrrServices": "Services",
      "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
      "httpMethod": "HTTP Method",
      "httpMethodDefault": "POST (default)",
      "httpMethodTooltip": "HTTP method for the webhook request. Defaults to POST.",
      "webhookPlaceholder": "https://example.com/webhook",
      "customHeaders": "Custom Headers",
      "customHeadersHelp": "Comma-separated KEY=value pairs (e.g., Authorization=Bearer token,X-Custom=value)",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=value"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC networks and channels. Click on a network to view channel status.",
      "addNew": "Add new",
      "networkHealthy": "Network healthy",
      "networkUnhealthy": "Network unhealthy",
      "networkDisabled": "Network disabled",
      "collapseTitle": "collapse",
      "expandTitle": "expand",
      "collapse": "Collapse",
      "expand": "Expand",
      "network": "Network",
      "noNetworks": "No networks",
      "noNetworksSubtitle": "Normally set up via Indexers",
      "addNewNetwork": "Add new network",
      "toggleSuccess": "{{name}} was {{state}} successfully.",
      "enabledState": "enabled",
      "disabledState": "disabled",
      "connectedSince": "Connected since: {{time}}",
      "tlsSecured": "Secured using TLS",
      "tlsInsecure": "Insecure, not using TLS",
      "channel": "Channel",
      "monitoringSince": "Monitoring since",
      "lastAnnounce": "Last announce",
      "monitoring": "monitoring",
      "hide": "Hide",
      "view": "View",
      "networkDeleted": "Network {{name}} was deleted",
      "networkRestarted": "{{name}} was successfully restarted",
      "removeNetworkTitle": "Remove network: {{name}}",
      "removeNetworkText": "Are you sure you want to remove this network? This action cannot be undone.",
      "edit": "Edit",
      "restart": "Restart",
      "delete": "Delete",
      "announceReprocessed": "Announce sent to re-process!",
      "reprocessAnnounce": "Re-process announce",
      "options": "Options",
      "scrollOnNewMessage": "Scroll to bottom on new message",
      "title": "Network",
      "addWarning": "ADD NETWORKS VIA INDEXERS! ONLY USE THIS IF YOU DELETED NETWORKS",
      "added": "IRC Network added. Please allow up to 30 seconds for the network to come online.",
      "addFailed": "IRC Network could not be added",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "required": "Required",
      "name": "Name",
      "enabled": "Enabled",
      "server": "Server",
      "serverPlaceholder": "Address: Eg irc.server.net",
      "port": "Port",
      "portPlaceholder": "Eg 6667",
      "tls": "TLS",
      "skipTls": "Skip TLS verification (insecure)",
      "password": "Password",
      "passwordHelp": "Network password",
      "passwordUpdateHelp": "Network password, not commonly used.",
      "nick": "Nick",
      "nickPlaceholderAdd": "bot nick",
      "nickPlaceholderUpdate": "nick",
      "authAccount": "Auth Account",
      "authAccountPlaceholder": "Auth Account",
      "authPassword": "Auth Password",
      "inviteCommand": "Invite command",
      "channels": "Channels",
      "channelsDesc": "Channels to join.",
      "channelsUpdateDesc": "Channels are added when you setup IRC indexers. Do not edit unless you know what you are doing.",
      "channelPassword": "Channel password",
      "remove": "Remove",
      "noChannels": "No channels!",
      "addChannel": "Add Channel",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Bouncer address",
      "bouncerAddressHelp": "Address: Eg bouncer.server.net:6697",
      "botMode": "IRCv3 Bot Mode",
      "proxy": "Proxy",
      "proxyDesc": "Set a proxy to be used for connecting to the IRC server.",
      "selectProxy": "Select proxy",
      "selectProxyPlaceholder": "Select a proxy",
      "identification": "Identification",
      "identificationDesc": "Identify with SASL or NickServ. Most networks support SASL but some don't.",
      "mechanism": "Mechanism",
      "account": "Account",
      "accountHelp": "NickServ / SASL account. For grouped nicks try the main.",
      "passwordSaslHelp": "NickServ / SASL password.",
      "chooseType": "Choose a type"
    },
    "indexer": {
      "title": "Indexer",
      "addTitle": "Add indexer",
      "addDescription": "Add indexer.",
      "added": "Indexer was added",
      "addFailed": "Indexer could not be added",
      "updated": "{{name}} was updated successfully",
      "deleted": "{{name}} was deleted.",
      "indexer": "Indexer",
      "chooseIndexer": "Choose an indexer",
      "required": "Required",
      "defaultValueValidation": "Default value, please edit",
      "enabled": "Enabled",
      "baseUrl": "Base URL",
      "baseUrlHelp": "Override base URL if it's blocked by your ISP.",
      "cancel": "Cancel",
      "save": "Save",
      "closePanel": "Close panel",
      "ircTitle": "IRC",
      "ircDesc": "Networks and channels are configured automatically in the background.",
      "torznabTitle": "Torznab",
      "torznabDesc": "Torznab feed",
      "newznabTitle": "Newznab",
      "newznabDesc": "Newznab feed",
      "rssTitle": "RSS",
      "rssDesc": "RSS feed",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "Networks and channels are configured automatically in the background.",
      "ircGuideTooltip": "Please read our IRC guide if you are unfamiliar with IRC.",
      "name": "Name",
      "url": "URL",
      "torznabUrlHelp": "Torznab URL. Use only the URL without extra params.",
      "newznabUrlHelp": "Newznab URL. Use only the URL without extra params.",
      "urlFormatTitle": "Prowlarr and Jackett have different formats:",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "API key",
      "downloadType": "Download type",
      "downloadTypeTooltip": "Some feeds need to be forced to Magnet.",
      "downloadTypeHelp": "Set to Torrent or Magnet depending on the indexer.",
      "downloadTypeTooltip2": "Some feeds need to be forced to Magnet.",
      "categoriesTitle": "Categories",
      "categoriesDescription": "Fetch available categories and select what to include.",
      "fetch": "Fetch",
      "fetching": "Fetching",
      "refetch": "Refetch",
      "fetchFailed": "Failed to fetch categories",
      "fetchNeedsUrl": "Enter a URL to fetch categories",
      "noCategories": "No categories found.",
      "fetchToSelect": "Fetch categories to select.",
      "testApi": "Test API",
      "testApiSuccess": "API test successful!",
      "ok": "OK!",
      "error": "ERROR",
      "externalIdentifier": "External Identifier",
      "externalIdentifierHelp": "External Identifier for ARRs. If using Prowlarr set like: {{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "External Identifier for use with ARRs to get features like seed limits working.",
      "externalIdentifierTooltip2": "This needs to match the indexer name in your ARR. If using Prowlarr it will likely be \"{{name}} (Prowlarr)\"",
      "secretFieldTooltip": "This field does not take a full URL. Only use alphanumeric strings like uqcdi67cibkx3an8cmdm.",
      "proxy": "Proxy",
      "proxyDesc": "Set a proxy to be used for downloads of .torrent files and feeds.",
      "selectProxy": "Select proxy",
      "selectProxyPlaceholder": "Select a proxy",
      "chooseType": "Choose a type"
    },
    "releaseProfile": {
      "title": "Duplicate Profile",
      "added": "Profile was added",
      "addFailed": "Profile could not be added",
      "deleted": "Profile {{name}} was deleted!",
      "fields": {
        "name": "Name",
        "releaseName": "Release name",
        "hash": "Hash",
        "title": "Title",
        "subTitle": "Sub Title",
        "year": "Year",
        "month": "Month",
        "day": "Day",
        "source": "Source",
        "resolution": "Resolution",
        "codec": "Codec",
        "container": "Container",
        "dynamicRange": "Dynamic Range",
        "audio": "Audio",
        "group": "Group",
        "season": "Season",
        "episode": "Episode",
        "website": "Website/Service",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "Edition",
        "hybrid": "Hybrid version",
        "language": "Language"
      },
      "descriptions": {
        "releaseName": "Full release name",
        "hash": "Normalized hash of the release name. Use with Release name for exact match",
        "title": "Parsed title",
        "subTitle": "Parsed Sub Title like Episode Name",
        "dailyReleases": "For daily releases",
        "group": "Release group",
        "website": "Services such as AMZN/HULU/NF",
        "dynamicRange": "Dynamic Range (HDR,DV etc)",
        "edition": "Edition and Cut",
        "language": "Language and Region"
      }
    },
    "cleanupJob": {
      "title": "Cleanup Job",
      "created": "Cleanup job created",
      "createFailed": "Job could not be created",
      "updated": "Job updated",
      "updateFailed": "Job could not be updated",
      "deleted": "{{name}} deleted",
      "enableDesc": "Enable this cleanup job",
      "namePlaceholder": "Weekly Cleanup",
      "schedule": "Schedule (Cron)",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Cron expression. Examples: '0 3 * * *' = daily 3 AM, '0 */6 * * *' = every 6 hours",
      "olderThan": "Older than",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "Delete releases older than this duration",
      "indexersOptional": "Indexers (Optional)",
      "statusesOptional": "Statuses (Optional)",
      "leaveEmptyIndexers": "Leave empty to apply to all indexers",
      "leaveEmptyStatuses": "Leave empty to apply to all statuses",
      "executionHistory": "Execution History",
      "lastRun": "Last Run:",
      "status": "Status:"
    }
  },
  "listScreens": {
    "common": {
      "enabled": "Enabled",
      "name": "Name",
      "type": "Type",
      "edit": "Edit",
      "addNew": "Add new",
      "unknownError": "An unknown error occurred"
    },
    "downloadClients": {
      "title": "Download Clients",
      "description": "Manage download clients.",
      "host": "Host",
      "noItems": "No download clients",
      "addNewItem": "Add new client",
      "toggleSuccess": "{{name}} was {{state}} successfully.",
      "enabledState": "enabled",
      "disabledState": "disabled"
    },
    "notifications": {
      "title": "Notifications",
      "description": "Configure notification services and their global event triggers.",
      "events": "Events",
      "filters": "Filters",
      "noItems": "No notifications",
      "addNewItem": "Create new notification",
      "infoTitle": "Per-filter overrides:",
      "infoBody": "You can override these global settings for specific filters in each filter's Notifications tab. Global events are optional - you can create notification services without any events and configure them only at the filter level. System events (IRC disconnected/reconnected, app updates) always use global settings.",
      "toggleSuccess": "{{name}} was {{state}} successfully.",
      "enabledState": "enabled",
      "disabledState": "disabled"
    },
    "indexers": {
      "title": "Indexers",
      "description": "Indexer settings for IRC, RSS, Newznab, and Torznab based indexers.",
      "descriptionGeneric": "Generic RSS/Newznab/Torznab feeds can be added here by selecting one of the <strong>Generic</strong> indexers.",
      "implementation": "Implementation",
      "noItems": "No indexers",
      "addNewItem": "Add new indexer",
      "updated": "{{name}} was updated successfully"
    },
    "proxies": {
      "title": "Proxies",
      "description": "Proxies that can be used with Indexers, feeds and IRC.",
      "noItems": "No proxies",
      "addNewItem": "Add new proxy",
      "toggleSuccess": "Proxy {{name}} was {{state}} successfully.",
      "toggleError": "Proxy state could not be updated",
      "enabledState": "enabled",
      "disabledState": "disabled"
    },
    "lists": {
      "title": "Lists",
      "description": "Lists can automatically update your filters from arrs or other sources.",
      "filters": "Filters",
      "noItems": "No lists",
      "addNewItem": "Add new list",
      "toggleSuccess": "List {{name}} was {{state}} successfully.",
      "toggleError": "List state could not be updated",
      "refreshSuccess": "List {{name}} was fetched successfully.",
      "refreshError": "Failed to refresh {{name}}. Error: {{error}}",
      "deleted": "{{name}} was deleted.",
      "removeTitle": "Remove list: {{name}}",
      "removeText": "Are you sure you want to remove this list? This action cannot be undone.",
      "copyId": "Copy List ID",
      "copyIdSuccess": "List ID {{id}} copied to clipboard.",
      "refresh": "Refresh",
      "delete": "Delete",
      "enabledState": "enabled",
      "disabledState": "disabled"
    },
    "feeds": {
      "title": "Feeds",
      "description": "Manage RSS, Newznab, and Torznab feeds.",
      "lastRun": "Last run",
      "nextRun": "Next run",
      "noItems": "No feeds",
      "noItemsDesc": "Setup via indexers",
      "toggleSuccess": "{{name}} was {{state}} successfully.",
      "enabledState": "enabled",
      "disabledState": "disabled",
      "deleted": "Feed {{name}} was deleted",
      "cacheCleared": "Feed {{name}} cache was cleared!",
      "forceRunSuccess": "Feed {{name}} was force run successfully.",
      "forceRunError": "Failed to force run {{name}}. Error: {{error}}",
      "removeTitle": "Remove feed: {{name}}",
      "removeText": "Are you sure you want to remove this feed? This action cannot be undone.",
      "removeCacheTitle": "Remove feed cache: {{name}}",
      "removeCacheText": "Are you sure you want to remove the feed cache? This action cannot be undone.",
      "forceRunTitle": "Force run feed: {{name}}",
      "forceRunText": "Are you sure you want to force run the {{name}} feed? Respecting RSS interval rules is crucial to avoid potential IP bans.",
      "toggle": "Toggle",
      "forceRun": "Force run",
      "viewLatestRun": "View latest run",
      "clearCache": "Clear feed cache",
      "clearCacheTitle": "Manually clear all feed cache",
      "delete": "Delete"
    }
  }
}
